



















































































import { Component, Vue, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
import { edit as EditBundle } from "@/dialogs/bundle";
import { Package } from "@/models/package";
import { Bundle } from "@/models/bundle";
import ProductIcon from "@/components/ProductIcon.vue";
const log = NSLog("view/ManagePackages");

@Component({
  components: {
    loader,
    EditBundle,
    ProductIcon
  }
})
export default class ManagePackages extends Vue {
  private loading = false;
  private saving = false;
  private onlyVisible = true;
  filterSrcRegion = "";
  filterDstRegion = "";
  filterCurrency = "";
  pagination = {
    descending: false,
    sortBy: "title",
    rowsPerPage: -1,
  };

  regions = [{ value: '', text: "Any" }, { value: 'us', text: "US" }, { value: 'za', text: "ZA" }, { value: 'ca', text: "CA" }];
  currencies = [{ value: '', text: "Any" }, { value: "USD", text: "USD" }, { value: "ZAR", text: "ZAR" }];

  public availableFromPicker = false;
  public expiryPicker = false;

  private bundles: Bundle[] = [];
  public packages: Package[] = [];

  //   get filterredBundles(){
  //     return this.bundles.filter()
  //     filterSrcRegion
  // filterDstRegion
  // filterCurrency
  //   }

  public created() {
    this.refreshBundles();
  }


  @Getter("packages") storePackages!: Package[];
  private async refreshBundles() {
    this.loading = true;
    try {
      const bundles = await billingApi.listBundlesNoCache();
      if (this.storePackages) {
        this.packages = this.storePackages;
      } else {
        this.packages = await billingApi.listPackages();
      }

      this.bundles = bundles
        .filter((b: Bundle) => {
          if (this.filterCurrency && b.currency != this.filterCurrency) return false;
          if (this.filterSrcRegion && b.src_region != this.filterSrcRegion) return false;
          if (this.filterDstRegion && b.dst_region != this.filterDstRegion) return false;
          return true;
        })
        .map((b: Bundle) => ({
          ...b,
          price: (b.package_short_codes || []).reduce((v: number, sCode: any) => {
            return v + (this.packages.find((p) => p.short_code && p.is_visible_now && p.short_code == sCode) || { price: 0 }).price
          }, 0)
        }))
    } catch (err) {
      log("err", err);
    }

    this.loading = false;
  }

  private bundle: Bundle | boolean = false;
  editBundle(bdl: Bundle) {
    this.bundle = {
      ...bdl, // copy
    };
  }
  bundleUpdated(newBundle: Bundle | false) {
    if (newBundle == false) {
      this.bundle = false;
      return;
    }

    const oldBundle = (this.bundle as Bundle);
    newBundle._oldCode = oldBundle.code;

    // will be a bundle
    const idx = this.bundles.findIndex((b) => b.id === oldBundle.id);
    this.bundles.splice(idx, 1, newBundle)
    this.bundle = false;
    // if (v) {
    //   this.refreshBundles();
    // }
  }

  public headers = [
    // { text: "Ss Code", value: "_ssCode" },
    { text: "ID", value: "id" },
    { text: "Code", value: "code" },
    { text: "Currency", value: "currency" },
    { text: "Src Region", value: "src_region" },
    { text: "Dst Region", value: "dst_region" },
    { text: "Title", value: "title" },
    { text: "Description", value: "description" },
    { text: "Price", value: "currency" },
    { text: "Long Description", value: "long_description" },
    // { text: "Is Public", value: "is_public" },
    // { text: "Expiry", value: "expiry" },
    // { text: "Available From", value: "available_from" },
    // { text: "Sku", value: "sku" },
    // { text: "Version", value: "version" },
    // { text: "Created At", value: "created_at" },
    // { text: "Updated At", value: "updated_at" },

    { text: "", value: "" }
  ];

}
